import { useSignupClaimQuery } from 'shared/hooks/queries/use-signup-claim-query';

export const useSignupClaim = (claimToken?: string) => {
  const { data } = useSignupClaimQuery(claimToken);

  return data ?? undefined;
};
